<template>
    <div>
        <modal
            class="new-modal-default"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            :max-height="300"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important; height: 30em !important;">
                <div class="v-modal-header text-center">
                    <span class="v-modal-dialog-title v-modal-title">FORWARD CALL REPORT</span>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout">
                        <div class="form-group pt-0">
                            <span class="text-secondary whiteSpace fs-14 fw-600">
                            Add Email Recipients
                            </span>
                            <multiselect
                            class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                            name="email_recipients"
                            v-validate="'required'"
                            @search-change="searchCustomerInside"
                            @open="searchCustomerInside"
                            @close="search_key = ''"
                            v-model="recipient_email"
                            :searchable="true"
                            :block-keys="['Tab']"
                            :loading="isLoading"
                            :preserve-search="true"
                            placeholder="Select Email Recipients"
                            :options="optionsEmailRecipients"
                            :multiple="true"
                            :close-on-select="false"
                            :show-labels="false"
                            :clear-on-select="false"
                            :hide-selected="false"
                            :taggable="true"
                            label="email"
                            track-by="email"
                            @tag="addCustomer"
                            >
                            <template slot="tag" slot-scope="{ option, remove }">
                                <span class="custom__tag">
                                <span>{{ option.email }}</span>
                                <span class="custom__remove" @click="remove(option)">
                                    <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfListCustomer" />
                            </template>
                            <span
                                slot="noResult"
                                class="font-weight-bold text-center d-block"
                            >No Results Found.</span>
                            </multiselect>
                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('email_recipients')">Email Recipients is Required</span>
                        </div>
                        <div class="d-flex aligin-items-center justify-content-end mt-6">
                            <button
                                type="button"
                                :disabled="disableSendBtn"
                                class="btn btn-des btn-new-danger btn-smm"
                                style="box-shadow: none;min-width: 10rem;"
                                @click="hideSelf"
                            >Cancel</button>
                            <button
                                type="button"
                                :disabled="disableSendBtn"
                                class="btn btn-des btn-new-green btn-smm ml-4"
                                style="box-shadow: none;min-width: 10rem;"
                                @click="forwardCallReport"
                            >Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <confirm-submit-callreport modal_name="confirmSubmitCR" @callReportData="forwardCallReportConfirm" @cancelreportData="cancelreportData"></confirm-submit-callreport>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import ConfirmSubmitCallreport from "./alertModals/ConfirmSubmitCallreport";
import leads from './mixins/leads';
import { SweetModal } from 'sweet-modal-vue';
import { EventBus } from './eventBus/nav-bar-event';
export default {
    data() {
        return {
            disableSendBtn: false,
            warning_msg: '',
            optionsEmailRecipients: [],
            search_key: "",
            recipient_email: [],
            email_regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/,
            skip: 0,
            limit: 10,
            search_term: '',
            isLoading: false,
        }
    },
    mixins: [leads],
    props: ["modal_name","id"],
    components: {
        SweetModal,
        ConfirmSubmitCallreport
    },
    methods: {
        cancelreportData(){
            this.$modal.hide("confirmSubmitCR")
        },
        forwardCallReport(){
            this.$validator.validateAll().then(result => {
                if (result) {
                    let domain = this.loggedInUser.primary_email.split('@')[1];
                    let otherEmail = this.recipient_email.filter(email => domain !=(email.email.split('@')[1]))
                    if( (otherEmail.length != 0)){
                        EventBus.$emit("otherDataEmail", otherEmail)
                        this.$modal.show("confirmSubmitCR")
                    }else{
                        this.forwardCallReportConfirm();
                    }
                }
            });
        },
        async searchCustomerInside(key) {
            this.isLoading = true;
            if (key) {
                this.search_term = key;
            }
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_term,
                company_id: this.loggedInUser.company_id,
                sort_key: 'full_name',
                sort_value: 1
            };
            let res = await this.getAssigned(params);
            this.count = 0;
            this.optionsEmailRecipients = res.response;
            this.isLoading = false;
        },
        async reachedEndOfListCustomer(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollableCustomer == false) {
                this.isLoading = true;
                let res = await this.getAssigned({
                    skip: this.optionsEmailRecipients.length,
                    limit: 10,
                    search_key: this.search_term,
                    company_id: this.loggedInUser.company_id,
                    sort_key: 'full_name',
                    sort_value: 1
                });
                if (res.response.length > 0) {
                    let tempFiles = res.response;
                    tempFiles.forEach(el => {
                    this.optionsEmailRecipients.push(el);
                    });
                    this.count += res.response.length;
                    this.isLoading = false;
                } else {
                    this.scrollableCustomer = true;
                    this.isLoading = false;
                }
                this.isLoading = false;
                }
            }
        },
        addCustomer(newTag) {
            const element = newTag;
            if (String(element).match(this.email_regex)) {
                this.optionsEmailRecipients.push({ email: element });
                this.recipient_email.push({ email: element });
            } else {
                this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                return;
            }
        },
        hideSelf() {
            this.recipient_email = [];
            this.$modal.hide(this.modal_name);
        },
        // forwardCallReport() {
        //     this.$validator.validateAll().then(result => {
        //         if (result) {
        //             this.forwardCallReportConfirm();
        //         }
        //     });
        // },
        async forwardCallReportConfirm() {
            this.disableSendBtn = true;
            try{
                let params = {
                    _id: this.id,
                    forward_to: [...new Set(this.recipient_email.map(x => x.email))],
                };
                let res = await this.$http.post("/call_report/forward", params);
                if (res.data.status_id == 1) {
                    this.$modal.hide("loader_modal");
                    this.hideSelf();
                    this.$swal({
                        text: "Call Report Sent Successfully",
                        type: "success",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#005dae",
                    });
                    this.disableSendBtn = false;
                } else {
                    reject(res.data.reason)
                }
                this.disableSendBtn = false;
            } catch(error) {
                this.warning_msg = error.res.data.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableSendBtn = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/CallReportForwardModal.vue